/**
 * Repetitively used Style Component across the app.
 */

import styled, { css } from 'styled-components';

import * as mx from 'core/styles/mixins';
import {
	caption,
	subHeadingSmall,
} from 'core/styles/Typography/Typography.style';

/* Add padding to the content */
export const ContentWithPadding = styled.div<{
	padding?: string;
	withBorderTop?: boolean;
	margin?: string;
}>`
	${({ withBorderTop, theme }) =>
		withBorderTop &&
		css`
			border-top: 1px solid ${theme.global.borders.hr};
		`}

	padding: ${({ padding }) => padding ?? '25px'};
	margin: ${({ margin }) => margin ?? '0'};
`;

export const EEFieldDefinitionList = styled.dl`
	padding: 0 10px;
	margin: 0;

	dt {
		${subHeadingSmall}
	}

	dd {
		${caption}
	}

	dd {
		margin-left: 0;
	}
`;

export const EECtaWrapper = styled.button`
	${mx.buttonReset}
`;
